import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '$shared/shared.module';
import { SharedBatchModule } from '../../shared-batch';
import { BlanksRoutingModule } from './blanks-routing.module';
import { BlanksComponent } from './blanks.component';
import { BlankItemComponent } from './components/blank-item/blank-item.component';
import { IndexComponent } from './pages/index/index.component';
import { FiltersComponent } from './components/filters/filters.component';

@NgModule({
  declarations: [
    IndexComponent,
    BlanksComponent,
    BlankItemComponent,
    FiltersComponent,
  ],
  imports: [CommonModule, SharedBatchModule, SharedModule, BlanksRoutingModule],
})
export class BlanksModule {}
